import React, { useState, useEffect } from 'react';
import {
    CardElement,
    PaymentRequestButtonElement,
    useStripe,
    useElements,
} from '@stripe/react-stripe-js';

const PaymentModal = ({ plan, closeModal }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [paymentRequest, setPaymentRequest] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    const planAmount = plan === "Basic Plan" ? 499 : 999; // Prices in pence

    useEffect(() => {
        if (stripe) {
            const pr = stripe.paymentRequest({
                country: 'GB',
                currency: 'gbp',
                total: {
                    label: plan,
                    amount: planAmount,
                },
                requestPayerName: true,
                requestPayerEmail: true,
            });

            pr.canMakePayment().then((result) => {
                if (result) setPaymentRequest(pr);
            });
        }
    }, [stripe, plan, planAmount]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!stripe || !elements) return;

        const cardElement = elements.getElement(CardElement);
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
        });

        if (error) {
            setErrorMessage(error.message);
            return;
        }

        // Call backend endpoint to create subscription here
        console.log('Payment Method created:', paymentMethod);
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
            <div className="bg-dark-100 text-white p-6 rounded-lg shadow-lg max-w-md w-full relative">
                <button
                    onClick={closeModal}
                    className="text-gray-500 absolute top-3 right-3 text-lg"
                >
                    ✕
                </button>

                <h2 className="text-2xl font-semibold mb-6 text-center text-white">
                    Subscribe to {plan}
                </h2>

                <div className="mb-6 p-4 bg-gray-900 rounded-lg">
                    <div className="flex justify-between text-lg mb-2">
                        <span>Plan:</span>
                        <span>{plan}</span>
                    </div>
                    <div className="flex justify-between text-lg mb-2">
                        <span>Total (Monthly):</span>
                        <span>£{(planAmount / 100).toFixed(2)}</span>
                    </div>
                </div>

                {paymentRequest ? (
                    <div className="mb-4">
                        <PaymentRequestButtonElement options={{ paymentRequest }} />
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="bg-gray-800 p-4 rounded-lg shadow-inner">
                            <label className="block mb-2 text-sm font-medium text-gray-400">
                                Card Details
                            </label>
                            <CardElement
                                options={{
                                    style: {
                                        base: {
                                            fontSize: '16px',
                                            color: '#FFFFFF',
                                            '::placeholder': {
                                                color: '#A0A0A0',
                                            },
                                        },
                                        invalid: {
                                            color: '#ff6868',
                                        },
                                    },
                                }}
                                className="space-y-3"
                            />
                        </div>

                        {errorMessage && <div className="text-red-500">{errorMessage}</div>}

                        <button
                            type="submit"
                            className="w-full py-3 bg-purple text-white font-semibold rounded-md shadow hover:bg-card-purple transition"
                        >
                            Pay £{(planAmount / 100).toFixed(2)} Monthly
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default PaymentModal;
